{
  "loading": "Ładowanie...",
  "placeholder": "Wybierz opcjęâ..."
}